<ng-select
  [ngModel]="selectedIds"
  [multiple]="true"
  [closeOnSelect]="false"
  [searchable]="searchable"
  [searchFn]="internalSearchFn"
  (ngModelChange)="onChange($event)">

  <ng-option [value]="ALL_TOKEN">All</ng-option>

  <ng-option
    *ngFor="let opt of options; trackBy: trackOption"
    [value]="opt[idField]">
    {{ opt[labelField] }}
  </ng-option>

  <!-- One summary pill regardless of how many items are selected. -->
  <ng-template ng-multi-label-tmp>
    <div class="ng-value" *ngIf="labelView.kind !== 'empty'">
      <span class="ng-value-icon left" (click)="onClear()" aria-hidden="true">x</span>
      <span class="ng-value-label">{{ labelView.text }}</span>
    </div>
  </ng-template>

  <!-- Custom row rendering: icon + name. Icon shows checked/unchecked state
       even when "All" is the underlying value (exclusion-tracking). -->
  <ng-template ng-option-tmp let-item="item">
    <ng-container *ngIf="item === ALL_TOKEN; else realOption">
      <i [ngClass]="iconClass(item)"></i>
      <strong>All</strong>
    </ng-container>
    <ng-template #realOption>
      <i [ngClass]="iconClass(item)"></i>
      {{ getLabel(item) }}
    </ng-template>
  </ng-template>

</ng-select>
